var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTicket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5 7.5h-6c-.276 0-.5.187-.5.417 0 .23.224.416.5.416H11v3.75c0 .23.224.417.5.417s.5-.187.5-.417v-3.75h2.5c.276 0 .5-.186.5-.416 0-.23-.224-.417-.5-.417z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 10c0 1.517 1.263 2.84 3 3.215v2.618H1v-2.618C2.737 12.84 4 11.517 4 10S2.737 7.16 1 6.785V4.167h21v2.618c-1.737.375-3 1.698-3 3.215zm3.571-2.462c.246-.03.429-.205.429-.412V3.75c0-.23-.224-.417-.5-.417H.5c-.276 0-.5.187-.5.417v3.376c0 .207.183.382.429.412C1.895 7.714 3 8.772 3 10c0 1.227-1.105 2.286-2.571 2.462-.246.03-.429.205-.429.412v3.376c0 .23.224.417.5.417h22c.276 0 .5-.187.5-.417v-3.376c0-.207-.183-.382-.429-.412C21.105 12.286 20 11.227 20 10c0-1.228 1.105-2.286 2.571-2.462z",
    fill: "#fff"
  })));
}
SvgTicket.displayName = 'Ticket';
export default SvgTicket;